// extracted by mini-css-extract-plugin
export var content = "_p9-1";
export var fullScreen = "_p9-0";